module.exports = __webpack_public_path__ + "img/image.4950d399.png";